import React from "react";
import { Grid } from "@material-ui/core/";
import TopItems from "./profileTopItems";
import ProfileForms from "./profileForms";
import Aux from "../../../hoc/Auxilliary";

const ApplicationProfile = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          <TopItems {...props} />
          <ProfileForms fields={props.fields} title={props.title} />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ApplicationProfile;
